import React, { useState } from "react";

// Quiet, section-level remove affordance: a muted uppercase label that
// turns red on hover. Renders nothing when there is nothing to remove,
// so it never competes with the content it sits beside.
export function RemoveAction({
    label,
    onClick = () => {},
    isVisible = true,
}) {
    const [isHovered, setIsHovered] = useState(false);

    if (!isVisible)
        return null;

    return (
        <span
            role="button"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="cp text-uppercase"
            style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.05em",
                color: isHovered ? "#F2545B" : "#868e96",
                transition: "color 0.15s ease-in-out",
            }}
        >
            {label}
        </span>
    );
}
